'use client';

import { useParams } from 'next/navigation';
import { useSyncExternalStore } from 'react';

import { DEFAULT_PERSONA_MODE, isPersonaMode, PersonaMode } from '@features/navigation/personaMode';
import { readPersonaModeCookie } from 'helpers/personaModeCookie';

// The cookie has no native change event; same-tab updates are driven by the URL,
// so an inert subscription is sufficient for the prefix-less fallback.
const subscribe = () => () => {};
const getStoredMode = (): PersonaMode => readPersonaModeCookie() ?? DEFAULT_PERSONA_MODE;

// The active mode is driven by the `[mode]` URL segment when present (app pages).
// On un-prefixed pages (e.g. settings) the URL has no mode, so we fall back to the
// persisted cookie. useSyncExternalStore keeps the cookie read SSR-safe (server
// snapshot = default) with no hydration mismatch.
export const useActivePersonaMode = (): PersonaMode => {
  const params = useParams();
  const urlMode = params?.mode;
  const storedMode = useSyncExternalStore(subscribe, getStoredMode, () => DEFAULT_PERSONA_MODE);

  if (isPersonaMode(urlMode)) {
    return urlMode;
  }
  return storedMode;
};
